module.exports = __webpack_public_path__ + "img/grommets-standard.3eb70790.jpg";